module.exports = __webpack_public_path__ + "static/media/tabs-icon-02.8165a1ba.svg";